import { createContext, useContext } from "react";

export type SliderContextValue = {
  min: number;
  max: number;
  step: number;
  orientation: "horizontal" | "vertical";
};

// Base UI keeps its root context private, so the wrapper republishes the few
// props the marks need to place themselves.
export const SliderContext = createContext<SliderContextValue>({
  min: 0,
  max: 100,
  step: 1,
  orientation: "horizontal",
});

export function useSliderContext(): SliderContextValue {
  return useContext(SliderContext);
}
